<div class="w-40">
  <app-model-field-percentage
    [id]="'attribute-percentage-' + testIdKey()"
    [value]="displayValue() ?? null"
    (valueChange)="onValueChange($event)"
    [isReadOnly]="disabled()"
    [placeholder]="'provider.tenderResponse.subcriteriaAttributes.enterPercentage' | transloco"
  />
</div>
